import React from "react";
import { useNavigate } from "react-router-dom";
import "./offerings.css";
import Lottie from "react-lottie-player";
import AccountOpening from "../../../../../assets/images/account-opening.json";
import FundsApproval from "../../../../../assets/images/funds-approval.json";
import FixSpecification from "../../../../../assets/images/fix-specification.json";
import TradingAPI from "../../../../../assets/images/trading-api.json";
import JournalAPI from "../../../../../assets/images/journal-api.svg";
import { IsAuthenticated } from "helpers";

function Offering() {
  const navigate = useNavigate();

  return (
    <div className="wrap-offerings" id="api-offerings">
      <div className="container">
        <div className="row">
          <h2 className="offering-title">API Offerings</h2>
          <p className="offering-desc">
            Easy-to-use APIs to onboard new accounts, trade and manage your
            portfolio, <br /> customize fund transfer workflows and more.
          </p>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="off-grid-wrap">
              <Lottie
                loop
                controls={true}
                animationData={AccountOpening}
                play
                style={{ width: 70, height: 70 }}
              />
              <h3 className="off-grid-title">Account Opening API</h3>
              <p className="off-grid-desc">
                Onboard new users in accordance with compliance needs
              </p>
              {IsAuthenticated() ? (
                <button
                  className="off-grid-link"
                  onClick={() => {
                    navigate("/products");
                  }}
                >
                  View More
                </button>
              ) : (
                <button
                  className="off-grid-link"
                  onClick={() => {
                    navigate("/authentication/sign-up");
                  }}
                >
                  Register Now
                </button>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="off-grid-wrap">
              <Lottie
                loop
                controls={true}
                animationData={FixSpecification}
                play
                style={{ width: 60, height: 60 }}
              />
              <h3 className="off-grid-title space">FIX Specifications</h3>
              <p className="off-grid-desc">
                Harness the power of our FIX infrastructure in your products
              </p>
              {IsAuthenticated() ? (
                <button
                  className="off-grid-link"
                  onClick={() => {
                    navigate("/products");
                  }}
                >
                  View More
                </button>
              ) : (
                <button
                  className="off-grid-link"
                  onClick={() => {
                    navigate("/authentication/sign-up");
                  }}
                >
                  Register Now
                </button>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="off-grid-wrap">
              <img
                src={JournalAPI}
                alt="Journal API"
                style={{ width: 70, height: 70 }}
              />
              <h3 className="off-grid-title">Journal API</h3>
              <p className="off-grid-desc space">
                The Journal Entry API creates a CSV file, submits it to
                InteliClear, and emails relevant recipients.
              </p>
              {IsAuthenticated() ? (
                <button
                  className="off-grid-link"
                  onClick={() => {
                    navigate("/products");
                  }}
                >
                  View More
                </button>
              ) : (
                <button
                  className="off-grid-link"
                  onClick={() => {
                    navigate("/authentication/sign-up");
                  }}
                >
                  Register Now
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <div className="off-grid-wrap height">
              <Lottie
                loop
                controls={true}
                animationData={TradingAPI}
                play
                style={{ width: 60, height: 60 }}
              />
              <h3 className="off-grid-title space">Trading API</h3>
              <p className="off-grid-desc space">
                Trade equities, options, monitor positions
              </p>
              {IsAuthenticated() ? (
                <button
                  className="off-grid-link"
                  onClick={() => {
                    navigate("/products");
                  }}
                >
                  View More
                </button>
              ) : (
                <button
                  className="off-grid-link"
                  onClick={() => {
                    navigate("/authentication/sign-up");
                  }}
                >
                  Register Now
                </button>
              )}
            </div>
          </div>
          <div className="col-md-4">
            <div className="off-grid-wrap height">
              <Lottie
                loop
                controls={true}
                animationData={FundsApproval}
                play
                style={{ width: 70, height: 70 }}
              />
              <h3 className="off-grid-title">Funding API</h3>
              <p className="off-grid-desc space">
                Custom workflows for your fund transfers
              </p>
              {IsAuthenticated() ? (
                <button
                  className="off-grid-link"
                  onClick={() => {
                    navigate("/products");
                  }}
                >
                  View More
                </button>
              ) : (
                <button
                  className="off-grid-link"
                  onClick={() => {
                    navigate("/authentication/sign-up");
                  }}
                >
                  Register Now
                </button>
              )}
            </div>
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>
    </div>
  );
}

export default Offering;
